// 작업개시 세부 진행 — 상품(등록ID)별로 «지금 도는 작업»과 «이미지 몇 장째인가»를 둔다.
// 옵션이 많은 상품은 작업개시가 10분을 넘는데, 대기열 보고가 「작업개시 1/1」에 그대로 머물러
// 부르는 쪽(에이전트)이 멈춘 줄 알았다(2026-10-16 문제 보고 941B0D·574EED).
// 화면 대기열 보고(AIRocketReg cliPageWaitForQueue)가 formatWorkDetail 로 읽어 문구에 붙인다.
// 이 파일은 의존성이 없다(단위 시험이 그대로 올린다).

const STEP_LABELS = {
    seo: 'SEO',
    pricing: '가격',
    mainImage: '대표이미지',
    additionalImage: '추가이미지',
    detailImage: '상세이미지 번역',
    koreanLabel: '한글표시사항',
    sizeChart: '사이즈표',
    quotation: '견적서',
};
const STEP_ORDER = Object.keys(STEP_LABELS);

const byProduct = new Map(); // registrationId → { running: Set<task>, counts: { task: {k, n} }, startedAt }
// 바뀔 때 알릴 곳 — 이 Map 은 화면 값이 아니라 Vue 가 모른다. 목록 칸(«처리중 12/50»)이 이걸로 다시 그린다.
const listeners = new Set();
function notify() {
    listeners.forEach(fn => {
        try { fn(); } catch (e) { console.error('[workProgress] 알림 처리 실패:', e); }
    });
}

export function onWorkProgress(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

function entry(registrationId) {
    const id = String(registrationId);
    let e = byProduct.get(id);
    if (!e) {
        e = { running: new Set(), counts: {}, startedAt: Date.now() };
        byProduct.set(id, e);
    }
    return e;
}

export function markStepStart(registrationId, task) {
    if (registrationId === undefined || registrationId === null) return;
    const e = entry(registrationId);
    e.running.add(task);
    delete e.counts[task];
    notify();
}

export function markStepEnd(registrationId, task) {
    const e = byProduct.get(String(registrationId));
    if (!e) return;
    e.running.delete(task);
    delete e.counts[task];
    notify();
}

// 이미지 k/n — k 는 끝낸(또는 집은) 장 수
export function setStepCount(registrationId, task, k, n) {
    if (registrationId === undefined || registrationId === null || !(n > 0)) return;
    entry(registrationId).counts[task] = { k: Math.min(Math.max(0, k), n), n };
    notify();
}

export function resetProduct(registrationId) {
    byProduct.delete(String(registrationId));
    notify();
}

// 목록 칸에 붙일 「12/50」 — 그 작업이 도는 중이고 장수를 알 때만
export function formatStepCount(registrationId, task) {
    const e = byProduct.get(String(registrationId));
    if (!e || !e.running.has(task)) return '';
    const c = e.counts[task];
    return c ? `${c.k}/${c.n}` : '';
}

export function getWorkDetail(registrationId) {
    const e = byProduct.get(String(registrationId));
    if (!e) return null;
    return { running: Array.from(e.running), counts: { ...e.counts }, startedAt: e.startedAt };
}

// 「대표이미지 5/25 · 상세이미지 번역 6/18 · 11:43 시작」
// 경과 시간을 문구에 넣지 않는다 — 문구가 매번 바뀌면 진행이 멈춰도 데몬의 멈춤 판정(진행 무변화 30분)이 영영 안 걸린다.
// 대신 시작 시각(고정)을 넣어 부르는 쪽이 경과를 셀 수 있게 한다.
export function formatWorkDetail(detail) {
    if (!detail) return '';
    const running = new Set(detail.running || []);
    const counts = detail.counts || {};
    const parts = [];
    STEP_ORDER.forEach(task => {
        if (!running.has(task)) return;
        const c = counts[task];
        parts.push(c ? `${STEP_LABELS[task]} ${c.k}/${c.n}` : STEP_LABELS[task]);
    });
    if (detail.startedAt) {
        const d = new Date(detail.startedAt);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        parts.push(`${hh}:${mm} 시작`);
    }
    return parts.join(' · ');
}
